const FixedServiceEnum = {
  ELECTRIC: 1,
  WATER: 2,
  MANAGEMENT: 3
}

export default FixedServiceEnum


// WEBPACK FOOTER //
// ./src/enum/fixedServiceEnum.js